module.exports = __webpack_public_path__ + "static/img/city-mob-red-1.3315c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/city-mob-red-1.png
// module id = 1071
// module chunks = 173